import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import heateron from '../assets/heateron.svg'
import heateroff from '../assets/heateroff.svg'
import Switch  from './switch';
import chaletStore from '../state/chaletstore';
import { HeatingDevice } from '../state/chalet.interface';
import { Form } from 'react-bootstrap';

class HeatingControl {
  name: string = '';
  id: string | undefined = undefined;
  ctype: number = 1;
}

const Controls: HeatingControl[] = [
  { name: 'Boiler', id: '1', ctype: 1 },
  { name: 'FloorHearting', id: '2', ctype: 2 },
  { name: 'ZoneValve', id: '3', ctype: 3 },
  { name: 'Fireplace', id: '4', ctype: 4 }
]

function ControlRow( {device, toggle} : {device:HeatingDevice, toggle: (roomId: string, deviceId: string, action: string, value: any) => void}) {
  var element = null
  switch (device.deviceType) {

    case 1: 
      element = <Row key={device.id}>
        <Col className='col-lg-3'>{device.name}</Col>
        <Col className='col-lg-2'> <Form>
            <Form.Check // prettier-ignore
              type="switch"
              checked={device.switch}
              onChange={(e) => toggle('noroom',device.id,'onOff','onoff') }
            />
          </Form></Col>
        <Col className='col-lg-3 text-center'>Bottom {device.temp2}</Col>
        <Col className='col-lg-3 text-center'>Top {device.temp1}</Col>
      </Row>
      break;
    case 2: // no swith , temp + state 
      element = <Row key={device.id}><Col className='col-lg-3'>{device.name}</Col>
        <Col className='col-lg-2'></Col>
        <Col className='col-lg-6 text-center' >{device.temp1} </Col>
        <Col className='col-lg-1 text-center'>{device.state ? 
          (<img src={heateron} width={24} height={24} alt="Logo" />) :
          (<img src={heateroff} width={24} height={24} alt="Logo" />) 
        }</Col>
      </Row>
      break;
    case 3: // switch + temp + state
      element = <Row key={device.id}><Col className='col-lg-3'>{device.name}</Col>
        <Col className='col-lg-2'> <Form>
            <Form.Check // prettier-ignore
              type="switch"
              checked={device.switch}
              onChange={(e) => toggle('noroom',device.id,'onOff','onoff') }
            />
          </Form></Col>
        <Col className='col-lg-6 text-center' >{device.temp1}</Col>
        <Col className='col-lg-1 text-center'> 
        {device.state ? 
          (<img src={heateron} width={24} height={24} alt="Logo" />) :
          (<img src={heateroff} width={24} height={24} alt="Logo" />) 
        }
        </Col>
      </Row>
      break;
    case 4:  // switch 
      element = <Row key={device.id}><Col className='col-lg-3'>{device.name}</Col>
        <Col className='col-lg-2'> <Form>
            <Form.Check // prettier-ignore
              type="switch"
              checked={device.switch}
              onChange={(e) => toggle('noroom',device.id,'onOff','onoff') }
            />
          </Form></Col>
        <Col className='col-lg-6 text-center' ></Col>
        <Col className='col-lg-1 text-center'></Col>
      </Row>
      break;

  }


  return element
}

function HeatingControlPanel() {

  const devices = chaletStore(state=>state.data.devices)
  const toggledevice = chaletStore((state) => state.updateDevice)

  const rows = []
  rows.push(<Row key='000' className='pb-3 headerrow'>
    <Col className='text-center col-lg-5'>Device</Col>
    <Col className='text-center col-lg-6'>Temperatur</Col>
    <Col className='text-center col-lg-1'>Status</Col>
  </Row>)
  for (const device_id in devices) {
    const device = devices[device_id]
    const row =
      <ControlRow key={device.id}  device={device} toggle={toggledevice}></ControlRow>
    rows.push(row)
  }
  return (<Container>{rows}</Container>)
}


export default HeatingControlPanel;